import { Component, OnInit, TemplateRef, ViewEncapsulation} from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { Title } from '@angular/platform-browser';
import { CartModuleConsts } from '../../contants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Apollo,  QueryRef } from 'apollo-angular';
import { getFeedbackFormDetails, getFeedbackFormDetailsPreprod } from 'src/app/feedback/feedbackquery';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/shared/services/shared.service';


@Component({
    selector: 'order-confirmation',
    templateUrl: './order-confirmation.component.html',
    styleUrls: ['./order-confirmation.component.scss',],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderConfirmationComponent implements OnInit {
  orderDetail: any;
  modalRef?: BsModalRef;
  max = 10;
  rate = 7;
  isRetailerOnly:any=false;
  isReadonly = false;
  isFirstOpen = false;
  isFirstOpen1 = true;
  surveyUrl: any ='';
  popuptext: any = '';
  selectedStore: any;
  isStoreSkiped:any = false;
  FEEDBACK_QUERY = getFeedbackFormDetails()
  FEEDBACK_QUERY_PREPROD = getFeedbackFormDetailsPreprod()
  CURENT_FEEDBACK_QUERY: any;
private query: QueryRef<any>;
  bannerDetails:any = {'bannerOrderCompleteImageWebsite':''};
  constructor(private statePersist: StatePersistService, private titleService: Title
    ,private modalService: BsModalService, private router: Router, private apollo: Apollo,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    var currentuser = this.statePersist.getLocalStorage('currentUser')
    this.selectedStore = this.statePersist.getLocalStorage('selectedStoreAddress')
    this.CURENT_FEEDBACK_QUERY = this.FEEDBACK_QUERY
    if(environment.environment == CartModuleConsts.PREPROD){
      this.CURENT_FEEDBACK_QUERY = this.FEEDBACK_QUERY_PREPROD
    }
    this.queryCalling()
    if (currentuser.is_telesales_user || currentuser.is_sales_rep || currentuser.is_head_office_user){
      this.isRetailerOnly = false
    }
    else{
      this.isRetailerOnly = true
    }
    this.titleService.setTitle(CartModuleConsts.ORDER_CONFIRMATION_PAGE_TITLE);
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.orderDetail = this.statePersist.getLocalStorage('order-detail')
    this.bannerDetails = this.statePersist.getLocalStorage('orderCompleteBannerImage') || this.bannerDetails
    document.getElementsByClassName('.col-12.banner-image')[0]['style'].backgroundImage  = "url("+this.bannerDetails.bannerOrderCompleteImageWebsite+")"
    this.miniCartDetails()
  }

  openModal(template: TemplateRef<void>) {
    var storedata = this.statePersist.getLocalStorage('skipFeedback') || {}
    if (storedata[this.selectedStore.selectedStoreAccountNo] == undefined){
      this.modalRef = this.modalService.show(template);
    }
    else{
      this.redirectToHome(false)
    }
    
  }

  queryCalling(){
    this.query = this.apollo.watchQuery({
      query: this.CURENT_FEEDBACK_QUERY,
      variables: {}
    });
    this.query.refetch()
    this.query.valueChanges.subscribe(result => {
      if(environment.environment == CartModuleConsts.PREPROD && result.data.wosSurveyUrlPreprods.length > 0){
        this.surveyUrl = result.data.wosSurveyUrlPreprods[0].surveyUrl
        this.popuptext = result.data.wosSurveyUrlPreprods[0].message
      }
      else if (result.data.wosSurveyUrls.length > 0){
        this.surveyUrl = result.data.wosSurveyUrls[0].surveyUrl
        this.popuptext = result.data.wosSurveyUrls[0].message
      }
      var skipdata = this.statePersist.getLocalStorage('skipFeedback') || {}
      if (skipdata[String(this.selectedStore.selectedStoreAccountNo)] !== undefined && skipdata[String(this.selectedStore.selectedStoreAccountNo)] !== this.surveyUrl.split('/zs/')[1]){
        this.statePersist.removeLocalStorage('skipFeedback')
        this.isStoreSkiped = false;
      }
      else if (skipdata[String(this.selectedStore.selectedStoreAccountNo)] !== undefined){
        this.isStoreSkiped = true;
      }
      
      
    });
  }

  skipSurvey(){
    var storedata = this.statePersist.getLocalStorage('skipFeedback') || {}
    storedata[this.selectedStore.selectedStoreAccountNo] = this.surveyUrl.split('/zs/')[1]
    this.statePersist.setLocalStorage('skipFeedback', storedata)
    this.redirectToHome(true)
  }

  redirectToFeedback(){
    this.modalRef.hide()
    this.router.navigate(['/feedback']);
  }

  redirectToHome(modelsopen:any=true){
    if (modelsopen){
      this.modalRef.hide()
    }
    
    this.router.navigate(['home']);
  }

  miniCartDetails() {
    this.sharedService.getminiCart()
      .subscribe(
        response => {
        }
      );
  }
}
